import { Component, inject, OnInit } from "@angular/core";

import { AccordionModule } from "primeng/accordion";
import { TagModule } from "primeng/tag";

import { SubPageComponent } from "@shared/components";
import { GlobalService } from "@shared/services";
import { KnownIssuesService } from "@features/about/services/known-issues.service";

@Component({
  selector: "app-known-issues",
  standalone: true,
  imports: [SubPageComponent, AccordionModule, TagModule],
  templateUrl: "./known-issues.component.html",
  styleUrl: "./known-issues.component.scss",
})
export class KnownIssuesComponent implements OnInit {
  knownIssuesService = inject(KnownIssuesService);
  globalService = inject(GlobalService);

  knownIssues: any;

  ngOnInit() {
    this.knownIssuesService.getKnownIssues().subscribe((knownIssues) => {
      this.knownIssues = knownIssues;
    });
  }

  getContainerHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px)`;
  }
}
